module.exports = __webpack_public_path__ + "img/category-sweaters.ff261ce8.jpg";